$(document).ready(function() {
  if ($('form[method="POST"]').length > 0 && window.location.search.length > 0) {
    history.pushState({}, '', window.location.origin + window.location.pathname);
  }
});

var Mi = typeof Mi !== 'undefined' ? Mi : {};
Mi.Misc = Mi.Misc || {};

/**d
 * Escapes given string.
 *
 * @param {string} s
 *   input.
 * @returns {string}
 *   output.
 */
RegExp.miEscape = (s) => {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

Mi.Misc.Tools = {

    /**
     * Set a cookie.
     *
     * @param {string} name
     *   Cookie name.
     * @param {string} value
     *   Cookie value.
     * @param {int} days
     *   Validity duration (in days).
     * @returns {undefined}
     */
    setCookie: function  (name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = '; expires=' + date.toGMTString();
        document.cookie = name + '=' + value + expires + ';path=/';
    },

    /**
     * Get a cookie.
     *
     * @param {any} name
     *   Cookie name.
     * @param {any} [defaultValue]
     *   Default value if cookie is not found. Null if missing.
     * @returns {mixed|null}
     *   Cookie value if defined, default value otherwise.
     */
    getCookie: function (name, defaultValue) {
        const n = name + '=';
        const cookie = document.cookie.split(';');
        for (var i = 0; i < cookie.length; i++) {
            let c = cookie[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(n) === 0) {
                return c.substring(n.length, c.length);
            }
        }
        return typeof defaultValue !== 'undefined' ? defaultValue : null;
    },

    /**
     *
     * @param {string} param Retrieving parameters from the url
     * @param {number|string} defaultValue Default value, if search parameter is
     *   not found. `''` by default
     * @returns {number|string} Value of sParam
     */
    getUrlParameter: function (param, defaultValue) {
        const parameters = this.getUrlParameters();
        return typeof parameters[param] !== 'undefined' ? parameters[param] : defaultValue;
    },

    /**
     *
     * @param {string} prmstr
     * @returns {object}
     */
    transformToAssocArray: function (prmstr) {
        const params = {};
        const prmarr = prmstr.split('&');
        for (let i = 0; i < prmarr.length; i++) {
            const tmparr = prmarr[i].split('=');
            params[tmparr[0]] = tmparr[1];
        }
        return params;
    },

    /**
     *
     * @returns {object}
     */
    getUrlParameters: function () {
        const prmstr = window.location.search.substr(1);
        return prmstr != null && prmstr !== '' ? this.transformToAssocArray(prmstr) : {};
    },

    /**
     * Converts text to a lowercase text by replacing spaces with hyphens
     * and escaping existing hyphens by doubling them.
     * @param {string} text - Input string to transform
     * @returns {string} Transformed text string
     */
    convertSpaceToDash: function(text) {
        return text.replaceAll('-', '--').replaceAll(' ', '-').toLowerCase();
    },

    /**
     * Restores text by converting hyphens to spaces and double hyphens back to single.
     * @param {string} text
     * @returns {string}
     */
    convertDashToSpace: function(text) {
        return text
            .replaceAll('--', '\u0000')
            .replaceAll('-', ' ')
            .replaceAll('\u0000', '-').toLowerCase();
    }
};

Mi.Misc.Gclid = {

    cookieDuration: 90,

    mainLogic: function () {
        this.collectParameters();
        this.injectParametersV1();
        this.injectParametersV2();
    },

    collectParameters: function () {

        const params = Mi.Misc.Tools.getUrlParameters();
        const gclParams = [];
        for (let param in params) {
            // If not gcl param, continue;
            if (param.indexOf('gcl') === -1) {
                continue;
            }
            // Otherwise, set cookie (so including "gclid" and
            // "gclsrc").
            gclParams.push(param);
            Mi.Misc.Tools.setCookie(param, params[param], this.cookieDuration);
        }
        if (gclParams.length > 0) {
            Mi.Misc.Tools.setCookie('gclparams', gclParams.join(','), this.cookieDuration);
        }

    },

    injectParametersCommon: function($form) {
        const gclParametersCookie = Mi.Misc.Tools.getCookie('gclparams', null);

        if (gclParametersCookie === null) {
            return;
        }

        const gclParams = gclParametersCookie.split(',');
        for (let param of gclParams) {
            const gclParamCookie = Mi.Misc.Tools.getCookie(param, null);
            if (gclParamCookie === null) {
                continue;
            }
            // Get associated input field.
            const formParam = param.replace(/^_/, '').toUpperCase() + '__c';
            const $gclInput = $('input[name="' + formParam + '"]');
            // If found, just inject value, otherwise we will create a hidden input to dynamically inject data.
            if ($gclInput.length > 0) {
                $gclInput.val(gclParamCookie);
            }
            else {
                $form.append($('<input name="' + formParam + '" type="hidden" value="' + gclParamCookie + '"/>'));
            }
            // Clear duplicates, keep only first element.
            $gclInput.slice(1).remove();
        }
    },

    injectParametersV1: function () {
        const $inputGclid = $('input[name="gclid"]');
        if ($inputGclid.length > 0) {
            const $form = $inputGclid.parents('form');
            Mi.Misc.Gclid.injectParametersCommon($form);
        }
    },

    injectParametersV2: function () {
        $('form').each(function (i, form) {
            const $form = $(form);
            if (typeof $form.attr('action') !== 'undefined' && $form.attr('action').indexOf('salesforce') === -1) {
                return;
            }
            Mi.Misc.Gclid.injectParametersCommon($form);
        });
    }

};

Mi.Misc.Social = {

    /**
     * @returns {undefined}
     */
    mainLogic: function () {
        this.loadSocials();
    },

    /**
     * @returns {string}
     *   Blog page title.
     */
    getDescription: function () {
        return $('meta[property="og:description"]').attr('content').trim().replace(/[%#<>]/g, '');
    },

    /**
     * @returns {string}
     *   Blog page title.
     */
    getImage: function () {
        return $('meta[property="og:image"]').attr('content').replace(/[%#<>]/g, '');
    },

    /**
     * @returns {undefined}
     */
    loadSocials: function () {

        var module = Mi.Misc.Social;

        $('.mi-social-hub-item--facebook').each(function () {
            var $this = $(this);
            var params = {
                u: window.location.href,
                text: Mi.Misc.Social.getDescription(),
                imgUrl: $this.attr('data-image'),
            };
            module.socialClickBehavior($this, 'https://www.facebook.com/sharer/sharer.php', params);
        });

        $('.mi-social-hub-item--twitter').each(function () {
            var params = {
                url: window.location.href,
                text: Mi.Misc.Social.getDescription(),
                via: 'markem-imaje',
            };
            module.socialClickBehavior($(this), 'https://twitter.com/intent/tweet', params);
        });

        $('.mi-social-hub-item--linkedin').each(function () {
            var params = {
                url: window.location.href,
                title: Mi.Misc.Social.getDescription(),
                image: Mi.Misc.Social.getImage()
            };
            module.socialClickBehavior($(this), 'https://www.linkedin.com/shareArticle', params);
        });
    },

    /**
     *
     * @param {object} $elem
     *   JQuery element to click on.
     * @param {string} url
     *   Share API URL.
     * @param {object} params
     *   Share API parameters like page url, description, images...
     * @returns {undefined}
     */
    socialClickBehavior: function ($elem, url, params) {
        $elem.click(function (e) {
            window.open(url + '?' + $.param(params), 'pop', 'width=600, height=400, scrollbars=no');
            e.preventDefault();
            return false;
        });
    }
};

$(document).ready(function () {
    window.dataLayer.push(function () {
        const event = this.get('event');
        const inboundAttribution = this.get('Inbound Attribution');
        if (event === 'consent_status' && inboundAttribution) {
            Mi.Misc.Gclid.mainLogic();
        }
    });

    Mi.Misc.Social.mainLogic();
});

Mi.Misc.Gclid.mainLogic();
